import React from "react";
import { MODEL_KEY } from "config/products";
import WatchUltra4Detail from "./WatchUltra4Detail";

function Watch12Cellular() {
  return <WatchUltra4Detail modelId={MODEL_KEY.WATCHSERIES12CELLULAR} />;
}

export default Watch12Cellular;
